import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'
import { contractActions, modalDialogActions } from '../../redux'
import messages from '../../i18n'
import styles from './../../constants/styles.scss'
import { PrintLoader } from '../../components/PrintLoader/PrintLoader'
import { ErrSuccess } from '../../types/form'
import { API_ERROR } from '../../constants/modals'
import { Response } from '../../api/api'

interface DispatchProps {
  startPrintPreContract: (callbacks: ErrSuccess) => void
  showModalDialog: Function
}

type Props = IntlInterface & WizardInterface & DispatchProps

export class PrintPreContract extends React.Component<Props> {
  componentDidMount(): void {
    this.init()
  }

  onInitError = (errorType: Response) => {
    this.props.showModalDialog(
      API_ERROR({
        errorInfo: { type: errorType },
        onRetry: this.init,
      })
    )
  }

  init = () => {
    this.props.startPrintPreContract({
      success: this.props.wizard.gotoNext,
      error: this.onInitError,
    })
  }

  render() {
    return (
      <PrintLoader
        subtitle={this.props.translate(messages.printPreContract.subTitle)}
        warning={this.props.translate(messages.printPreContract.warning)}>
        {this.props.translate(messages.printPreContract.titleA)}
        <span className={styles.infoText}>
          {this.props.translate(messages.printPreContract.titleB)}
        </span>
        {this.props.translateHTML(messages.printPreContract.titleC)}
      </PrintLoader>
    )
  }
}

const mapDispatchToProps: DispatchProps = {
  startPrintPreContract: contractActions.startPrintPreContract,
  showModalDialog: modalDialogActions.showModalDialog,
}

const enhance = compose(intl, wizard, connect(null, mapDispatchToProps))

export default enhance(PrintPreContract)
